export { default } from './RegistrationOrderEdit'



// WEBPACK FOOTER //
// ./src/App/pages/RegistrationOrderEdit/index.js